import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBauJ5Jl7AUuLLYTNRsyNRx_3YwiWBF8TE",
  authDomain: "macron-generator.firebaseapp.com",
  projectId: "macron-generator",
  storageBucket: "macron-generator.appspot.com",
  messagingSenderId: "995756839803",
  appId: "1:995756839803:web:813b6da2f4622fd55523de",
  measurementId: "G-LMT0TZCJP7",
};

const firebase = initializeApp(firebaseConfig);

export default firebase;
export const firestore = getFirestore(firebase);
export const analytics = getAnalytics(firebase);
